import React from 'react';
import {useTranslation} from "react-i18next";
import './face-analyzing-anim.styles.css';

const FaceAnalyzingAnimComponent = ({image_url, process_name}) => {
    const {t} = useTranslation("common");
    return (
        <div className="w-full flex flex-col items-center justify-center h-full animCard" style={{gap: '16px'}}>
            <div className="scan text-center flex justify-between gap-3 rounded-xl overflow-hidden relative" style={{maxWidth: '400px', maxHeight: '400px', width: '100%', aspectRatio: '1/1'}}>
                <img src={image_url}
                     className="face"
                     style={{objectFit: 'contain', width: '100%', height: '100%'}}/>
                <div className="absolute top-0 left-0 w-full h-full bg-black opacity-5"/>
                <div
                    className="absolute top-0 left-0 w-full h-full bg-gradient-to-b from-black from-1% to-80% to-transparent"/>
                <div
                    className="absolute top-0 left-0 w-full h-full bg-gradient-to-t from-black  from-1% to-80% to-transparent"/>
                <div className="line"/>
            </div>
            <div style={{textAlign: 'center', color: '#666', width: '100%'}}>
                <p style={{fontSize: '15px', fontWeight: 500, marginBottom: '6px', margin: 0}}>
                    {t("please_wait_analyzing") || "Please wait while we analyze the image..."}
                </p>
                <p style={{fontSize: '13px', color: '#999', margin: '6px 0'}}>
                    {process_name === 'wrinkles' 
                        ? (t("analyzing_wrinkles") || "Analyzing wrinkles...") 
                        : process_name === 'skin_lesions'
                        ? (t("analyzing_skin_lesions") || "Analyzing skin lesions...")
                        : (t("please_wait") || "Please wait...")}
                </p>
                <div style={{
                    marginTop: '12px',
                    padding: '10px',
                    background: 'rgba(102, 126, 234, 0.1)',
                    borderRadius: '8px',
                    fontSize: '12px',
                    color: '#667eea'
                }}>
                    {t("image_will_be_added_after_analysis") || "Image will be added to comparison after analysis completes"}
                </div>
            </div>
        </div>
    );
};

export default FaceAnalyzingAnimComponent;